import axios from 'axios';

import LOCAL_STORAGE_KEYS from 'constants/localStorageKeys';
import AppRoutes from 'routes/routes';
import { removeFromLocalStorage } from 'utils/localStorage';

class ApiClient {
  constructor() {
    // Create an Axios instance with base URL and default headers
    this.client = axios.create({
      baseURL: `${process.env.REACT_APP_API_URL}`,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  // Set the authorization token for the API requests
  setAuthToken(token) {
    this.authToken = token;
    if (token) {
      this.client.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
      delete this.client.defaults.headers.common['Authorization'];
    }
  }

  // Set the header for form data
  setHeaderFormData() {
    this.client.defaults.headers['Content-Type'] = 'multipart/form-data';
  }

  // Set the header for image sercurity
  setHeaderImage(url, etag) {
    this.client.defaults.baseURL = url;
    this.client.defaults.headers['x-goog-if-match'] = etag;
    delete this.client.defaults.headers.common['Authorization'];
  }

  // Set custom header
  setCustomHeader(key, value) {
    this.client.defaults.headers[key] = value;
  }

  // Reset the header to default JSON content type
  resetHeader() {
    this.client.defaults.baseURL = `${process.env.REACT_APP_API_URL}`;
    this.client.defaults.headers['Content-Type'] = 'application/json';
    this.client.defaults.headers['lang'] = 'ja';
    this.client.defaults.headers.common['Authorization'] = `Bearer ${this.authToken}`;
  }

  // Handles the successful response from the API
  handleResponse(response) {
    return {
      headers: response.headers,
      data: response.data,
      status: response.status,
      statusText: response.statusText,
    };
  }

  // Handles the error response from the API
  handleError(error) {
    return {
      error: error.response?.data?.message || 'Internal Server Error',
      jp_message: error.response?.data?.jp_message || 'Internal Server Error',
      status: error.response?.status || 500,
      statusText: error.response?.statusText || 'Internal Server Error',
    };
  }

  // Makes a request to the API
  async request(method, url, data, options = {}) {
    try {
      const response = await this.client.request({
        method,
        url,
        ...(data ? { data: data } : {}),
        ...options,
      });
      return this.handleResponse(response);
    } catch (error) {
      if (error.status === 403 && this.client.defaults.baseURL === process.env.REACT_APP_API_URL) {
        removeFromLocalStorage(LOCAL_STORAGE_KEYS.TOKEN);
        window.location(AppRoutes.login);
      }
      return this.handleError(error);
    }
  }
}

export default new ApiClient();
